
import { defineComponent } from "vue";
import PlanetMobile from "@/components/mobile/PlanetMobile.vue";
import PlanetTablet from "@/components/tablet/PlanetTablet.vue";
import PlanetDesktop from "@/components/desktop/PlanetDesktop.vue";

export default defineComponent({
  name: "Home",
  components: { PlanetMobile, PlanetTablet, PlanetDesktop },
});
